(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-inline-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeTradeEmptySuggestions = () => {
      document.querySelectorAll('predictive-search[data-trade-empty-suggestions]').forEach((search) => {
        if (search.dataset.tradeEmptySuggestionsReady === 'true') return;

        const input = search.querySelector('input[type="search"]');
        const results = search.querySelector('[data-predictive-search]');
        if (!input || !results) return;

        const initialMarkup = results.innerHTML;

        const openEmptySuggestions = () => {
          if (input.value.trim()) return;

          if (!results.querySelector('#predictive-search-results-groups-wrapper')) {
            results.innerHTML = initialMarkup;
          }

          search.setAttribute('results', 'true');
          if (typeof search.open === 'function') {
            search.open();
          } else {
            search.setAttribute('open', 'true');
            input.setAttribute('aria-expanded', 'true');
            search.isOpen = true;
          }
        };

        input.addEventListener('focus', openEmptySuggestions);
        input.addEventListener('click', openEmptySuggestions);
        search.dataset.tradeEmptySuggestionsReady = 'true';
      });
    };

    if (customElements.get('predictive-search')) {
      initializeTradeEmptySuggestions();
    } else {
      customElements.whenDefined('predictive-search').then(initializeTradeEmptySuggestions);
    }

    document.addEventListener('shopify:section:load', initializeTradeEmptySuggestions);
  })();
  } catch(e) { console.error(e); }
})();

})();
